import {
    reachIamTokenRetrieval,
    ReachIamTokenRetrievalInstance,
} from '@reachmedianetwork/iam-token';
import { ILog } from '../AuxillaryService/Log';
import axios from 'axios';
import { assert } from '../Utility/assert';

interface IamConfig {
    baseUrl: string;
    clientId: string;
    clientSecret: string;
    sharedSecret: string;
    playerUuid: string;
    hardwareId: string;
    log: ILog;
}

let _reachIamConfig: Pick<IamConfig, 'baseUrl' | 'log'> | undefined;

export function setReachIamInstance({
    baseUrl,
    clientId,
    clientSecret,
    sharedSecret,
    playerUuid,
    hardwareId,
    log,
}: IamConfig): void {
    assert(_reachIamConfig === undefined, 'REACH IAM has already been configured.');

    _reachIamConfig = {
        baseUrl,
        log,
    };

    _reachIam = reachIamTokenRetrieval()
        .setEndpoint(`${baseUrl}/auth/token`)
        .setTimeProvider(getTimeFromServer)
        .setSecrets({
            clientId,
            clientSecret,
            sharedSecret,
        });

    if (playerUuid && hardwareId) {
        _reachIam.setPlayerId(playerUuid, hardwareId);
    }
}

/**
 * acquires a unix timestamp (millis) from central server or Date.now() if the
 * central server cannot be accessed.
 */
async function getTimeFromServer(): Promise<number> {
    assert(_reachIamConfig !== undefined, 'REACH IAM has not be configured.');

    const { baseUrl, log } = _reachIamConfig;
    try {
        const response = await axios.get(`${baseUrl}/system/time`);
        const timestamp = response.data.timestamp;

        if (typeof timestamp === 'number') {
            //do not refactor this to the top of the function. It is important
            //that we call Date.now *after* the REST call completes.
            const now = Date.now();

            if (Math.abs(timestamp - now) > 60000) {
                log.Info(
                    `player time is significantly different than central server; server: ${timestamp}, local: ${now}`,
                    null,
                    __fileline
                );
            }

            log.Debug(
                `using server timestamp ${timestamp} to compute TOTP password`,
                null,
                __fileline
            );

            return timestamp;
        }
    } catch (e) {
        log.Warning('failed to acquire timestamp from server', null, __fileline, e);
    }

    const now = Date.now();

    log.Debug(`using local timestamp ${now} to compute TOTP password`, null, __fileline);

    return now;
}

/** The shared REACH IAM Token Retrieval instance */
let _reachIam: ReachIamTokenRetrievalInstance;

/**
 * Retrieve a REACH IAM Player Token
 *
 * This creates a singleton that will store the token while it's valid and
 * return a new one when the previous expires.
 */
export async function retrievePlayerIamToken(): Promise<string> {
    assert(_reachIam !== undefined, 'No REACH IAM instance found.');

    return _reachIam.retrievePlayerToken();
}
